export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6953.a51dd1ba.jpg";